import { create } from 'zustand';
import getValue from 'get-value';
import stringTemplate from 'string-template';
import MarkdownWithHtml from 'markdown-to-jsx';

// WEA-157 — valeur d'interpolation GLOBALE injectée dans toutes les trads : `{$legendrate}` se
// remplit automatiquement avec le taux Legend+ (mois legend), piloté par l'env Next
// NEXT_PUBLIC_HOF_LEGEND_DISCOUNT_PERCENT (entier %, défaut 50). Évite de passer `percent` à chaque
// t() pour les libellés "−50%". Même clé que le backend (HOF_LEGEND_DISCOUNT_PERCENT).
const GLOBAL_TRAD_VARS = {
  legendrate: (() => {
    const pct = Number(process.env.NEXT_PUBLIC_HOF_LEGEND_DISCOUNT_PERCENT);
    return Number.isFinite(pct) ? pct : 50;
  })(),
};

const useZusTranslate = create((set) => ({
  lang: 'fr',
  setTradData: (data, lang) => set((state) => ({
    ...state,
    ...((lang ?? 'toto') !== 'toto' ? { lang: lang || 'fr' } : {}),
    data: {
      ...(state?.data || {}),
      ...(data || {}),
    },
  })),
}));

const useTranslation = () => ({
  lang: useZusTranslate.getState().lang,
  t: (str, value, { tradDatas = null } = {}) => {
    if (!str) return '';
    const newStr = str?.replace?.(':', '.') || '';
    let newTrad = getValue(tradDatas || useZusTranslate.getState().data, newStr);
    // `defaultValue` : texte de repli tant que la clé n'est pas dans l'API i18n.
    const { defaultValue, ...templateValues } = value || {};
    if (!newTrad) return defaultValue ?? str;
    if (typeof newTrad === 'string') {
      // {$legendrate} est rempli GLOBALEMENT (taux Legend+ depuis l'env Next) même sans valeur
      // passée au t(). Les autres placeholders gardent le comportement d'origine (templatés
      // seulement si une valeur est fournie) — on ne veut pas blanchir un {$var} non fourni.
      const hasGlobal = newTrad.includes('{$legendrate}');
      newTrad = newTrad.replaceAll('{$', '{');
      if (hasGlobal || Object.entries(templateValues).length) {
        newTrad = stringTemplate(newTrad, { ...GLOBAL_TRAD_VARS, ...templateValues });
      }
    }

    return newTrad;
  },
});
function useLang() {
  const { lang: currentLang } = useTranslation();
  return currentLang;
}
// eslint-disable-next-line react/prop-types
function Markdown({ children, ...props }) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MarkdownWithHtml {...props}>{children || ''}</MarkdownWithHtml>;
}

export const hocTranslateServerClient = (Component) => function ({ tradFromServer, locale, ...props }) {
    if ((tradFromServer ?? 'toto') !== 'toto') {
      // console.trace(tradFromServer);
      // useZusTranslate.getState().setTradData(tradFromServer, locale);
      useZusTranslate.setState({
        data: {
          ...(useZusTranslate?.getState()?.data || {}),
          ...tradFromServer,
        },
      });
    }
    const { t: tClient } = useTranslation();
    const t = (str, value) => tClient(str, value);
    return <Component t={t} {...props} locale={locale} />;
  };

export {
 Markdown, useLang as lang, useTranslation, useZusTranslate,
 hocTranslateServerClient as hocT,
};
